import { LockPlusIcon } from './LockPlusIcon';

/**
 * author: Colton Wiscombe
 * id BA4D2E1E-2BCB-4B17-AC02-52C8F34FAEAE
 * name lock-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-plus.svg
 * tags
 * - Lock 
 */
export const EncryptionAddIcon = LockPlusIcon;
export default EncryptionAddIcon